<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end">
  <button mat-raised-button class="primary-btn filled-btn" (click)="dismiss()">{{ data.button || 'Got it' }}</button>
</div>
